{
  "order": {
    "completionRule": "يكتمل تلقائياً عند استلام كل الكميات المطلوبة أو إقفالها بنقص، وتسجيل فاتورة مورد واحدة على الأقل.",
    "completionCancelled": "ينتهي الأمر الملغى هنا، ولا يُعدّ مكتملاً.",
    "cancelledQuantity": "غير مسلَّم (ملغى)",
    "cancelledNotice": {
      "title": "هذا الأمر ملغى",
      "body": "لا يُنتظر عليه أي تسليم آخر، ولا يمكن تسجيل استلام جديد. ما وصل يبقى مسجلاً كمستلم، أما الباقي المعروض أدناه كغير مسلَّم فقد أُلغي."
    }
  }
}
